export const REVERSAL_FLAG = 'CONTACT_REVERSAL_STATUSES'

export const REVERSAL_STATUS_VALUES = ['chargeback', 'refunded']

export const isReversalOffice = (customSettings) => customSettings?.reversalStatusesAllowed === true
